let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eQEen")).then(() => parcelRequire('8B7Mv'));